import { inject, observer } from 'mobx-react';
import React from 'react';
import { STORE_CONVERSATION, STORE_UI } from '../../constants/stores';
import { Channel } from '../../containers/Channel';
import { IGroupInfoProps } from './interface.d';

const GroupInfo = (props: IGroupInfoProps) => {
  const {
    ui: { groupModalOpen },
  } = props;

  return groupModalOpen ? (
    <Channel openGroupModal={groupModalOpen} {...props} />
  ) : (
    <></>
  );
};

export default inject(STORE_CONVERSATION, STORE_UI)(observer(GroupInfo));
